import axios from "axios";

export function downloadPdf(file, name) {
    // iOS（Safari / Chrome / WebView）在异步回调中阻止程序化点击触发下载，
    // 且 iOS 本身不支持 <a download> 属性将 PDF 保存到本地。
    // 直接在新标签页打开 PDF，由用户自行保存。
    const isIOS = /iPad|iPhone|iPod/.test(navigator.userAgent) && !window.MSStream;
    if (isIOS) {
        window.open(file, '_blank');
        return;
    }

    axios({
        method: "get",
        url: file,
        responseType: "blob"
    }).then(function(response) {
        // console.log("11111111" + response)
        const link = document.createElement("a");
        let blob = new Blob([response.data], { type: response.data.type });
        if (window.navigator.msSaveBlob != undefined) {
            window.navigator.msSaveBlob(blob, `${name}.pdf`)
        } else {
            // console.log("2222222" + blob)
            let url = URL.createObjectURL(blob);
            link.href = url;
            // link.href = file;
            link.download = name;
            link.setAttribute('target', '_blank')
            document.body.appendChild(link)
            link.click();
            document.body.removeChild(link)
            window.URL.revokeObjectURL(url)

        }
    }).catch(err => {
        // console.log("下载错误" + err)
    })
}